
import React from 'react';
import { TextField, Grid, Typography, IconButton, Button } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Link, useHistory, useLocation } from 'react-router-dom';
import ArrowForwardSharpIcon from '@material-ui/icons/ArrowForwardSharp';
import useStyles from './styles';
import useCommonStyles from '../../../CommonStyle/commonStyle';
import useCommonAuthStyles from '../../commonAuthStyle';
import Input from '../../Input/Input';

interface signupProp {
    form: { firstName: string, lastName: string, spellFirstName: string, spellLastName: string, email: string, userID: string, profilePic: string, password: string, confirmPassword: string, userType: string },
    handleSubmit: ((e: React.FormEvent<HTMLFormElement>) => void),
    handleChange: ((e: React.ChangeEvent<HTMLInputElement>) => void),
    //   handleShowPassword: (() => void),
    //   handleShowRepeatPassword: (() => void),
    switchMode: (() => void),
    setNext: ((value: boolean) => void)
    //   showPassword: boolean,
    //   showRepeatPassword: boolean
}

const InfoSetup = ({ form, handleSubmit, handleChange, switchMode, setNext }: signupProp) => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const commonAuthClasses = useCommonAuthStyles();
    return (
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={3} className={commonAuthClasses.parentGridContainer}>
            <Grid item xs={9} sm={6} md={6} direction="column" alignItems="center" className={commonAuthClasses.leftGrid}>
                <Typography className={commonAuthClasses.motivationalTitle} >
                    プロフィールを作成しよう<br />
                </Typography>
                <Typography className={commonAuthClasses.subTitle}>
                    <span className={commonClasses.wrapSpan}>プロジェクトを投稿するにあたり、</span>
                    <span className={commonClasses.wrapSpan}>自分のことを周りの人に知ってもらいましょう。</span>
                </Typography >
            </Grid>
            <Grid container item xs={3} sm={6} md={6} className={commonAuthClasses.rightGrid} >

                <form name="profileInfoForm" className={classes.form} onSubmit={handleSubmit}>
                    <Grid container spacing={2}>

                        <Input name="lastName" label="姓（漢字）" handleChange={handleChange} placeholder="佐藤" half value={form.lastName} />
                        <Input name="firstName" label="名（漢字）" handleChange={handleChange} placeholder="太郎" autoFocus half value={form.firstName} />
                        <Input name="spellLastName" label="姓（フリガナ）" handleChange={handleChange} placeholder="サトウ" half value={form.spellLastName} />
                        <Input name="spellFirstName" label="名（フリガナ）" handleChange={handleChange} placeholder="タロウ" autoFocus half value={form.spellFirstName} />
                        <Input name="userID" label="ユーザーID" handleChange={handleChange} type="text" value={form.userID} />
                        <Input name="email" label="メールアドレス" handleChange={handleChange} type="email" value={form.email} />
                        <Link to="/startup/login" className={commonAuthClasses.hintLinkBtn}>アカウントをお持ちの方はこちら</Link>
                       
                    </Grid>
                    <Grid container alignItems="center" justifyContent="flex-end" className={classes.buttonsGrid}>
                        <Button type="submit" variant="contained" color="primary" className={commonAuthClasses.submit} onClick={() => setNext(true)} >
                            <ArrowForwardSharpIcon color="inherit" />
                        </Button>
                    </Grid>

                </form>
            </Grid>

        </Grid>
    )
};

export default InfoSetup;



